import { gql } from "@apollo/client"

const CREATE_BOOKING_SLOT_MUTATION = gql`
  mutation($input: CreateBookingSlotInput!) {
    createBookingSlot(input: $input) {
      id
      bookingSlots {
        id
        slot_id
      }
    }
  }
`

export { CREATE_BOOKING_SLOT_MUTATION }
